export const data3_2_1 = [{
    name: 'Cash 现金',
    name_code: 'Cash',
    Adjusted: '0',
    Debit: '0',
    Credit: '0',
    Current: '0',
    Comments: '',
}, {
    name: 'Bank Deposit 银行存款',
    name_code: 'Bank_Deposit',
    Adjusted: '0',
    Debit: '0',
    Credit: '0',
    Current: '0',
    Comments: '',
}, {
    name: 'Account Receivable 应收账款',
    name_code: 'Account_Receivable',
    Adjusted: '0',
    Debit: '0',
    Credit: '0',
    Current: '0',
    Comments: '',
}, {
    name: 'Inventories 存货',
    name_code: 'Inventories',
    Adjusted: '0',
    Debit: '0',
    Credit: '0',
    Current: '0',
    Comments: '',
}, {
    name: 'Account Payable 应付账款',
    name_code: 'Account_Payable',
    Adjusted: '0',
    Debit: '0',
    Credit: '0',
    Current: '0',
    Comments: '',
}, {
    name: 'Payroll Payable 应付职工薪酬',
    name_code: 'Payroll_Payable',
    Adjusted: '0',
    Debit: '0',
    Credit: '0',
    Current: '0',
    Comments: '',
}, {
    name: 'Taxes  Payable 应付税金',
    name_code: 'Taxes_Payable',
    Adjusted: '0',
    Debit: '0',
    Credit: '0',
    Current: '0',
    Comments: '',
}];




// WEBPACK FOOTER //
// ./src/components/table/9.0/9-1/data.js